import PubSub from "underpub-js";
import slick from "slick-carousel";

var Timeline = function (options) {

  this.options = {
    $el: false,
    baseClass: 'mol-Timeline',
  };

  $.extend(true, this.options, options);

};

Timeline.prototype.init = function () {

  var self = this;

  self.$navigationSlider = self.options.$el.find(`.${self.options.baseClass}__navigation__carousel`);
  self.$contentSlider = self.options.$el.find(`.${self.options.baseClass}__content__carousel`);
  self.$prevArrow = self.options.$el.find(`.${self.options.baseClass}__arrow--prev`);
  self.$nextArrow = self.options.$el.find(`.${self.options.baseClass}__arrow--next`);

  self.$navigationSlider.slick({
    asNavFor: self.$contentSlider,
    // slidesToScroll: 1,
    slidesToShow: 6,
    prevArrow: self.$prevArrow,
    nextArrow: self.$nextArrow,
    infinite: false,
    centerMode: false,
    centerPadding: 0,
    focusOnSelect: true,
    responsive: [{
        breakpoint: self.options.GLOBAL_VARIABLES.BREAKPOINTS.M,
        settings: {
          slidesToShow: 5,
        },
      },
      {
        breakpoint: self.options.GLOBAL_VARIABLES.BREAKPOINTS.S,
        settings: {
          slidesToShow: 4,
        },
      },
      {
        breakpoint: self.options.GLOBAL_VARIABLES.BREAKPOINTS.XS,
        settings: {
          slidesToShow: 3,
        },
      },
      {
        breakpoint: self.options.GLOBAL_VARIABLES.BREAKPOINTS.XXS,
        settings: {
          slidesToShow: 2,
        },
      }
    ],
  });

  self.$contentSlider.slick({
    asNavFor: self.$navigationSlider,
    arrows: false,
    fade: true,
  });

};

export default Timeline;